import {
  Container,
  Flex,
  Box,
  Text,
  Image,
  Center,
  Hide,
  Link,
} from '@chakra-ui/react';
import { withTrackingParams } from '../../../utils/trackingParams';
import logoSrc from '../../../assets/images/logo-light.png';
import iconLightSrc from '../../../assets/images/icon-light.svg';
import Stat from './Stat';

const TrialDetails = ({ isTeamMemberInvitation }) => {
  return (
    <Container
      bg="linear-gradient(180deg, #FF9554 16%, #FF6F45 55%, #FF4935 88%)"
      h="100%"
      minH="100vh"
      w="40vw"
      p={20}
      display={['none', 'none', 'none', 'block']}
    >
      <Flex direction="column" h="100%" gap={20}>
        <Link isExternal href={withTrackingParams('https://passentry.com')}>
          <Image src={logoSrc} alt="logo" w="12vw" />
        </Link>
        {!isTeamMemberInvitation ? (
          <Flex
            direction="column"
            mt="15vh"
            justifyContent="space-between"
            h="100%"
          >
            <Box>
              <Text
                textStyle="headingFamilyRegular"
                fontSize="36px"
                color="white"
                lineHeight="130%"
              >
                Start issuing your passes in minutes with your{' '}
                <Text as="span" textStyle="headingFamilyBold">
                  free 14-day trial.
                </Text>
              </Text>
              <Text textStyle="heading2" fontSize="20px" color="white" mt={3}>
                No card required. Upgrade anytime.
              </Text>
            </Box>
            <Hide below="xl">
              <Flex justifyContent="space-between" gap="6">
                <Stat value="170+" label="Companies on board" />
                <Stat value="92%" label="Pass retention rate" />
                <Stat value="<5mins" label="Onboarding time" />
              </Flex>
            </Hide>
          </Flex>
        ) : (
          <Center h="85%">
            <Image src={iconLightSrc} alt="sign-up" w="60%" h="60%" />
          </Center>
        )}
      </Flex>
    </Container>
  );
};

export default TrialDetails;
